<script setup>
import {onBeforeMount, ref, nextTick} from "vue";
import router from "@/router/index.js";
import createBrandMember from "./components/createBrandMember/index.vue"
import {getRoute} from "@/hooks/getRoute.js";
import {editServiceProviderIgnoreTenant, getServiceProviderIgnoreTenant} from "@/api/serviceProvider/ignoreTenant.js";

const {route} = getRoute()

// 服务商（品牌方员工）ID
const providerId = ref()
onBeforeMount(async () => {
  if (!route.query.tenantId) {
    loading.value = true
    ElMessage.error("暂无摄影服务商信息")
  } else if (!route.query.providerId) {
    loading.value = true
    ElMessage.error("暂无品牌方员工信息")
  } else {
    ruleForm.value.tenantId = route.query.tenantId
    ruleForm.value.storeId = route.query.storeId
    providerId.value = route.query.providerId
    await getDetail()
  }
})
// 加载状态
const loading = ref(false)
/*表单信息相关*/
// 表单
const ruleForm = ref({
  tenantId: null,
  storeId: null,
  avatar: null,
  name: null,
  nameEn: null,
  phone: null,
  providerJobTitle: null,
  providerJobTitleEn: "Coming Soon ...",
  providerType: "BRAND_EMPLOYEE",
})
// 处理创建品牌方员工
const handleUpdateBrandMember = async () => {
  try {
    loading.value = true
    await editServiceProviderIgnoreTenant(ruleForm.value)
    ElMessage.success("修改成功")
    router.back()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 创建品牌方员工组件锚点
const createBrandMemberRef = ref()
// 获取品牌方员工信息
const getDetail = async () => {
  try {
    loading.value = true
    ruleForm.value = await getServiceProviderIgnoreTenant(providerId.value)
    createBrandMemberRef.value.handleReviewPic([ruleForm.value.avatar])
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <createBrandMember ref="createBrandMemberRef" v-loading="loading" v-model="ruleForm" :is-edit="true" @success="handleUpdateBrandMember"></createBrandMember>
</template>

<style lang="scss" scoped>

</style>
